import {Shift} from './types';

export const MockData: Shift[] = [
  {
    id: 6,
    membershipId: 2,
    teamId: 20,
    distrDate: '2021-02-08',
    startTime: '2021-02-08T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 7,
    membershipId: 2,
    teamId: 20,
    distrDate: '2021-02-09',
    startTime: '2021-02-09T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 8,
    membershipId: 2,
    teamId: 20,
    distrDate: '2021-02-10',
    startTime: '2021-02-10T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 9,
    membershipId: 2,
    teamId: 20,
    distrDate: '2021-02-11',
    startTime: '2021-02-11T02:00:00Z',
    durationMinutes: 200,
  },
  {
    id: 10,
    membershipId: 2,
    teamId: 20,
    distrDate: '2021-02-12',
    startTime: '2021-02-12T02:00:00Z',
    durationMinutes: 360,
  },
  {
    id: 11,
    membershipId: 3,
    teamId: 20,
    distrDate: '2021-02-08',
    startTime: '2021-02-08T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 12,
    membershipId: 3,
    teamId: 20,
    distrDate: '2021-02-09',
    startTime: '2021-02-09T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 13,
    membershipId: 3,
    teamId: 20,
    distrDate: '2021-02-10',
    startTime: '2021-02-10T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 14,
    membershipId: 3,
    teamId: 20,
    distrDate: '2021-02-11',
    startTime: '2021-02-11T02:00:00Z',
    durationMinutes: 200,
  },
  {
    id: 15,
    membershipId: 3,
    teamId: 20,
    distrDate: '2021-02-12',
    startTime: '2021-02-12T02:00:00Z',
    durationMinutes: 360,
  },
  {
    id: 1,
    membershipId: 4,
    teamId: 20,
    distrDate: '2021-02-08',
    startTime: '2021-02-08T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 2,
    membershipId: 4,
    teamId: 20,
    distrDate: '2021-02-09',
    startTime: '2021-02-09T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 3,
    membershipId: 4,
    teamId: 20,
    distrDate: '2021-02-10',
    startTime: '2021-02-10T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 4,
    membershipId: 4,
    teamId: 20,
    distrDate: '2021-02-11',
    startTime: '2021-02-11T02:00:00Z',
    durationMinutes: 200,
  },
  {
    id: 5,
    membershipId: 4,
    teamId: 20,
    distrDate: '2021-02-12',
    startTime: '2021-02-12T02:00:00Z',
    durationMinutes: 360,
  },
  {
    id: 16,
    membershipId: 5,
    teamId: 20,
    distrDate: '2021-02-08',
    startTime: '2021-02-08T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 17,
    membershipId: 5,
    teamId: 20,
    distrDate: '2021-02-09',
    startTime: '2021-02-09T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 18,
    membershipId: 5,
    teamId: 20,
    distrDate: '2021-02-10',
    startTime: '2021-02-10T02:00:00Z',
    durationMinutes: 300,
  },
  {
    id: 19,
    membershipId: 5,
    teamId: 20,
    distrDate: '2021-02-11',
    startTime: '2021-02-11T02:00:00Z',
    durationMinutes: 200,
  },
  {
    id: 20,
    membershipId: 5,
    teamId: 20,
    distrDate: '2021-02-12',
    startTime: '2021-02-12T02:00:00Z',
    durationMinutes: 360,
  },
];
